import React from "react";
import styled from "styled-components";
import PizzaLogo from "../assets/dishes-img/pizza-logo-white.png";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as Scooter } from "../assets/components-icons/scooter.svg";
import { UserContext } from "../context/user";
import { CartServerSide } from "../context/api_response";
import { Button } from "../components/Layout/Elements";
import { navlist } from '../helpers/navlist';

export default function NavBar() {
  const { total, userInfo, cart, orders } = React.useContext(CartServerSide);
  const { user, userLogout } = React.useContext(UserContext);
  let history = useHistory();

  const [linkId, setLinkId] = React.useState(0)
  const handleLink = (id) => {
    setLinkId(id)
  }

  return (
    <NavBarWrapper>
      <nav>
        <ul>
          <div>

            <li>

              <Link to="/">
                <img src={PizzaLogo} alt="" />
              </Link>
              
            </li>

          </div>
          <div>
            { navlist.map((item) => {
              return <span className={linkId === item.id && 'current-link'}  onClick={() => {
                history.push(`${item.link}`)
                handleLink(item.id)
              }} key={item.id}> { user.token ? item.text : item.textLogin } { orders.length > 1 && item.textOrder }   </span>
            }) }
            { user.token &&  <span onClick={userLogout}> Logout </span> }
          { user.token && <span>{userInfo.username}</span> }
          </div>

          <div className="d-block">
            <div>
              <small>
                Call and order in <span>Belgium</span>
              </small>
            </div>
            <div>
              <h1> 54 548 779 654 </h1>
            </div>

            {user.token && (
              <div className="d-flex ml-2">
                <div>
                  <Button
                    radius="50px"
                    bg="var(--successAlert)"
                    fontWeight="bold"
                    fontSize="12.5px"
                    padding="15px"
                    width="100%"
                    onClick={() => history.push("/cart-page")}
                  >
                    <Scooter />
                    {cart.length === 0 ? (
                      <span>Your order is empty</span>
                    ) : (
                      <span>
                        Your order:
                        <span>€ {total}</span>
                      </span>
                    )}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </ul>
      </nav>
    </NavBarWrapper>
  );
}

const NavBarWrapper = styled.div`
  nav {
    width: 100%;
    background: var(--navbar-bg);
    height: 150px;
  }

  ul,
  div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    list-style-type: none;
  }

   /* a {
    font-weight: bold;
    font-size: 15px;
    text-decoration: none;
    color: white;
    margin: 0px 0px 0px 20px;
  } */

  small {
    color: #ffae00;
    font-size: 13px;
  }

  span {
    color: white;
    font-size: 14px;
    margin: 0px 0px 0px 20px;
    font-weight: bold;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: var(--mainTransition);
  }

   .current-link {
    border-bottom: 2px solid #ffae00;
  }



  svg {
    width: 24px;
    height: 24px;
    fill: white;
  }

  h1 {
    font-size: 28px;
    color: white;
    font-weight: bolder;
  }

  img {
    height: 150px;
  }

  @media screen and (max-width: 1024px) {
    li span {
      font-size: 10px;
      padding: 1px;
    }
    ul {
      display: flex;
    }
    h1 {
      font-size: 15px;
    }
    span,
    small {
      font-size: 12px;
    }
    img {
      height: 100px;
    }
  }
`;
